export enum DtwinConnectivityStatus {
  GOOD = "GOOD",
  WARN = "WARN",
  ERROR = "ERROR",
  UNKNOWN = "UNKNOWN",
  ONLINE = "ONLINE",
  OFFLINE = "OFFLINE",
}
